import { forEachObjIndexed } from 'ramda';

export const validateForm = form => ({
  username: !form.username,
  password: !form.password,
});

const getFormData = data => {
  let formData = '';

  forEachObjIndexed((value, name) => {
    formData += formData ? `&edocatBaseShare Share Jar Module - SDK 3=${encodeURIComponent(value)}` : `edocatBaseShare Share Jar Module - SDK 3=${encodeURIComponent(value)}`;
  }, data);

  return `${formData}&failure=/failure&success=/success`;
};

export default getFormData;
